import { httpApi } from '@/api/http.api'

export type DashboardCardPositionDto = {
  deviceId: string
  x: number
  y: number
}

export type DashboardViewDto = {
  id: string
  name: string
  deviceIds: string[]
  positions: DashboardCardPositionDto[]
  updatedAt: string
}

export type DashboardViewsDto = {
  views: DashboardViewDto[]
  activeViewId: string
}

const DASHBOARD_VIEWS = 'dashboard-views'

export const getDashboardViews = (): Promise<DashboardViewsDto> =>
  httpApi.get<DashboardViewsDto>(DASHBOARD_VIEWS).then(({ data }) => data)

export const updateDashboardViews = (payload: DashboardViewsDto): Promise<DashboardViewsDto> =>
  httpApi.put<DashboardViewsDto>(DASHBOARD_VIEWS, payload).then(({ data }) => data)
